<div *ngIf="facade.loading()">
	Loading YAS schedule...
</div>

<ng-container *ngIf="!facade.loading()">
	<section *ngIf="facade.schedule() as s">

		<p-table *ngIf="s.attendance" [value]="s.attendance" [paginator]="false" sortMode="single" sortField="school" [sortOrder]="1">

			<!-- ===================== -->
			<!-- Header -->
			<!-- ===================== -->
			<ng-template pTemplate="header">
				<tr>

					<!-- Hide Checkbox Column -->
					<th style="width: 70px;">
						Hide
					</th>

					<!-- School Column -->
					<th pSortableColumn="school">
						School
						<p-sortIcon field="school"></p-sortIcon>
					</th>

					<!-- Member Column -->
					<th pSortableColumn="name">
						Member
						<p-sortIcon field="name"></p-sortIcon>
					</th>

				</tr>
			</ng-template>

			<!-- ===================== -->
			<!-- Body -->
			<!-- ===================== -->
			<ng-template pTemplate="body" let-member>

				<!-- ✅ Hide row if checkbox checked -->
				<tr *ngIf="!member.hidden">

					<!-- Checkbox -->
					<td>
						<input type="checkbox" [(ngModel)]="member.hidden" />
					</td>

					<!-- School -->
					<td>
						{{ member.school === 'none' ? '' : member.school }}
					</td>

					<!-- Name -->
					<td>
						{{ member.name }}
					</td>

				</tr>
			</ng-template>

		</p-table>

	</section>
</ng-container>

<div *ngIf="!facade.loading() && !facade.schedule()">
	No schedule found.
</div>